import { IAnalytics, IKeywordsGeneral, IKeywordsReport } from '../../../types'

export default class AnalyticData {

  [key: string]: string | any;

  weeklyReport?: IAnalytics;
  
  monthlyReport?: IAnalytics;
  
  yearlyReport?: IAnalytics;

  // topKeywords?: IKeywordsReport[];

  // extraKeywordsGeneral?: IKeywordsGeneral[];
  
  private static singleState: AnalyticData;
  
  private constructor(init?: any) {
  
    Object.assign(this, init);
  }

  private static get InitialState() {
  
    return {
      weeklyReport: {} as IAnalytics,
      monthlyReport: {} as IAnalytics,
      yearlyReport: {} as IAnalytics,
      // topKeywords: [] as IKeywordsReport[],
      // extraKeywordsGeneral: [] as IKeywordsGeneral[]
    };
  }
  
  public static getState(): AnalyticData {

    if (AnalyticData.singleState) {
  
      return AnalyticData.singleState;
    }
  
    return AnalyticData.singleState = new AnalyticData(AnalyticData.InitialState);
  }
  
  public static flushState(report?: string): void {
    
    if (report != undefined) {

      AnalyticData.singleState[report] = {} as IAnalytics;
    }

    AnalyticData.singleState = Object.assign(AnalyticData.singleState, AnalyticData.InitialState);
  }
}